export interface Product {
  id: string
  name: string
  price: number
  category: 'Books' | 'Apparel' | 'Media' | 'Gifts'
  image: string
  description: string
}

export const productsData: Product[] = [
  {
    id: 'book-1',
    name: 'The Power of Grace',
    price: 15.99,
    category: 'Books',
    image:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?auto=format&fit=crop&q=80&w=800',
    description:
      'A deep dive into the surpassing grace of God in our daily lives.',
  },
  {
    id: 'shirt-1',
    name: 'TheHousehold Signature Tee',
    price: 25.0,
    category: 'Apparel',
    image:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&q=80&w=800',
    description:
      'Comfortable cotton tee featuring the Household of Christ Church logo.',
  },
  {
    id: 'media-1',
    name: 'Worship Vol. 1 (CD)',
    price: 12.99,
    category: 'Media',
    image:
      'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&q=80&w=800',
    description:
      'A collection of live worship recordings from our Sunday services.',
  },
  {
    id: 'gift-1',
    name: 'Faith Journal',
    price: 18.5,
    category: 'Gifts',
    image:
      'https://images.unsplash.com/photo-1531346878377-a5be20888e57?auto=format&fit=crop&q=80&w=800',
    description:
      'Premium leather-bound journal for your prayers and reflections.',
  },
  {
    id: 'book-2',
    name: 'Walking in Purpose',
    price: 14.95,
    category: 'Books',
    image:
      'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&q=80&w=800',
    description: 'Discovering and fulfilling your God-given destiny.',
  },
  {
    id: 'shirt-2',
    name: 'Surpassing Grace Hoodie',
    price: 45.0,
    category: 'Apparel',
    image:
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?auto=format&fit=crop&q=80&w=800',
    description: 'Warm and cozy hoodie with the 2026 theme design.',
  },
]
